import { PLAYER_MESSAGES } from '~/utils/api-response/player'

// State
export const state = () => ({
  loading: false
})

// Actions
export const actions = {
  // Reset password
  doResetPassword({ commit }, form) {
    delete form.confirm_password
    return true
  },
  // Update player profile
  doUpdatePlayerProfile({ commit }, form) {
    this.$cookie.set('nickname', form.nickname)
  },
  // Forgot password
  async doDeleteSocial({ commit }, socialId) {},
  // Messages
  getMessage({ commit }, params) {
    const response = PLAYER_MESSAGES
    this.commit('player/setMessages', response.data)
  },
  async checkSuspendRegistration({ rootState, rootGetters }, currency) {},
  async checkRegistrationSetting({ _ }, params) {
    try {
      const response = await this.$axios.get(`/website-setting/registration-setting/${params}`)
      return response.data
    } catch (error) {}
  }
}

// Mutations
export const mutations = {
  setLoading(state, data) {
    state.loading = data
  }
}

// Getters
export const getters = {
  loading: state => state.loading
}
